import apiClient from '@/utils/axios'
import {ServiceNotice} from '@/types'
import {AxiosResponse} from 'axios'

const serviceNotice = {
  async getAllNotices(): Promise<AxiosResponse<ServiceNotice[]>> {
    const response = await apiClient.get('/notices/listings')
    return response
},
async markAsRead(id: number): Promise<AxiosResponse<ServiceNotice>> {
    const response = await apiClient.put(`/notices/markings/${id}`)
    return response
},
}

export {serviceNotice}
